import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout/Layout'
import Seo from '../components/Seo/Seo'
import RoutingEnum from '../routes/appRoutes'
import Hero from '../components/Hero/Hero'
import { MainContainer } from '../theme/mainContainer.styled'
import styled from 'styled-components'
import pxToRem from '../utils/pxToRem'
import Button from '../components/Button/Button'
import ButtonVariantEnum from '../enums/ButtonVariant'

const StyledMainContainer = styled(MainContainer)`
  padding: ${pxToRem(20)};
  background-color: ${({ theme }) => theme.colors.unique.white};
  border-radius: ${pxToRem(5)};
  height: auto;
`

const StyledDiv = styled.div`
  height: fit-content;
`
const title = 'Cookie Policy'
const isBrowser = typeof window !== `undefined`

const CookiePolicy = () => {
  useEffect(() => {
    isBrowser && window.OneTrust?.initializeCookiePolicyHtml()
  }, [isBrowser])


  return (
    <Layout>
      <Seo title={title} />
      <Hero
        title={title}
        pathname={RoutingEnum.cookiePolicy}
        slug={RoutingEnum.cookiePolicy}
      />
      {isBrowser ?
        (<StyledMainContainer>
          {/*OneTrust Cookies List start*/}
          <StyledDiv id='ot-sdk-cookie-policy'></StyledDiv>
          {/*OneTrust Cookies List end*/}
          {/*OneTrust Cookies Settings button start*/}
          <Button label={'Cookie Settings'} variant={ButtonVariantEnum.secondary}
                  onClick={() => isBrowser && window.OneTrust?.ToggleInfoDisplay()} />
          {/*OneTrust Cookies Settings button end*/}
        </StyledMainContainer>) : null

      }
    </Layout>
  )
}

export default CookiePolicy